module.exports = __webpack_public_path__ + "static/icon-d2e02a207cf89c93d739e581a9b6bd7b.jpg";